export const profile = {
  displayName: 'Rui Sá',
  initials: 'RS',
  location: 'Setúbal, Portugal',
  headline: 'Frontend engineer building clear, trustworthy product experiences.',
  shortBio:
    'I combine 4+ years of professional frontend delivery with ongoing Computer Engineering studies and a focus on React, TypeScript, product thinking, and testable UI.',
  availability: 'Available for 2027 graduate frontend opportunities',
  links: {
    github: 'https://github.com/ruimiguelyo',
    linkedin: 'https://www.linkedin.com/in/rui-s%C3%A1-1243162ab/',
  },
  experience: [
    {
      company: 'Deloitte',
      role: 'Frontend Developer',
      start: 'Oct 2021',
      end: 'Mar 2026',
      location: 'Portugal · Hybrid',
      summary:
        'Contributed to frontend delivery in a large consulting environment, working within team processes, delivery timelines, and shared quality expectations.',
      detail:
        'Built professional discipline while completing formal software engineering studies — an experience that shaped how I organise work, communicate progress, and keep learning.',
    },
  ],
  education: [
    {
      institution: 'Polytechnic Institute of Setúbal',
      qualification: 'BSc in Computer Engineering',
      start: null,
      end: 'Expected 2027',
    },
    {
      institution: 'Polytechnic Institute of Setúbal',
      qualification: 'CTeSP in Software Engineering',
      start: '2021',
      end: '2023',
    },
  ],
} as const;
